import * as action_types from './constants';

const initialState = {
  salesOrders: {},
  menu: []
};

export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case action_types.SALES_ORDER_LIST:
      return { ...state, salesOrders: data };

    default:
      return state;
  }
};
